import axios from 'axios';
export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'https://pmswebbackend.pixelmindsolutions.com').replace(
  /\/$/,
  '',
);
export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
});
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
export const endpoint = (path) => `${API_BASE_URL}${path || ''}`;
export const getErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  'Something went wrong';
export const unwrapList = (response) => {
  const payload = response?.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  // Supports grouped API responses, e.g. { data: { website: [], mobile-app: [] } }.
  if (payload?.data && typeof payload.data === 'object') {
    const groups = Object.values(payload.data);
    if (groups.length && groups.every(Array.isArray)) {
      return groups.flat();
    }
  }
  return [];
};
